// noinspection JSUnresolvedVariable
import {useEffect, useState} from 'react';
import Alert from '../../components/layout/Alert';
import api from '../../services/api';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {cnpj, cpf} from 'cpf-cnpj-validator';
import Input from '../../components/form/Input';
import Spinner from '../../components/button/Spinner';
import Select from '../../components/form/Select';

export default function UserForm() {
    const params = useParams();
    const {userId} = params;
    const isEdit = userId !== undefined;
    const location = useLocation();
    const isView = location.pathname.search('view') !== -1
    const inputs = [
        {
            type: 'text',
            name: 'name',
            label: 'Nome*',
            required: true,
        },
        {
            type: 'text',
            name: 'document',
            label: 'CPF/CNPJ',
            required: false,
        },
        {
            type: 'email',
            name: 'email',
            label: 'Email*',
            required: true,
        },
        {
            type: 'text',
            name: 'erpCode',
            label: 'ERP Codigo',
            required: false,
        },
        {
            type: 'password',
            name: 'password',
            label: 'Senha' + (isEdit ? '' : '*'),
            required: !isEdit
        },
        {
            type: 'password',
            name: 'passwordConfirm',
            label: 'Repetir senha' + (isEdit ? '' : '*'),
            required: !isEdit
        },

    ]
    const [showAlert, setShowAlert] = useState(false);
    const [alertColor, setAlertColor] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [user, setUser] = useState({});
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (isEdit) {
            setLoading(true);
            api
                .get('users/' + userId)
                .then((response) => setUser(response.data))
                .catch((err) => {
                    setAlertMessage('Erro ao carregar usuário');
                    setAlertColor('red');
                    console.error(err);
                })
                .finally(() => setLoading(false));
        }
        return () => {
            setUser({});
        };
    }, [isEdit, userId]);

    useEffect(() => {
        if (user.document && user.document.trim() !== '') {
            const numberPattern = /\d+/g;
            const documentNumbers = user.document.match(numberPattern);
            if (documentNumbers !== null) {
                if (documentNumbers.join('').length === 11) {
                    setUser({...user, document: cpf.format(user.document)});
                    return;
                }
                setUser({...user, document: cnpj.format(user.document)});
            } else {
                setUser({...user, document: ''});
            }
        }
    }, [user.document])

    const handleNew = () => {
        api
            .post('users', {
                ...user
            })
            .then(() => {
                setUser({name: '', document: '', erpCode: '', password: '', passwordConfirm: '',});
                setAlertMessage('Salvo com sucesso');
                setAlertColor('blue');
                setShowAlert(true)
            })
            .catch((err) => {
                setAlertColor('red');
                setShowAlert(true);
                if (err.response.status) {
                    const errors = err.response.data.errors;
                    if (err.response.status === 422) {
                        setAlertMessage(errors[Object.keys(errors)[0]][0])
                        return;
                    }
                }
                setAlertMessage('Erro ao Atualizar. Por favor tente novamente mais tarde.');
                console.log(err);
            })
            .finally(() => setLoading(false));
    }

    const handleEdit = () => {
        api
            .put('users/' + userId, {
                ...user
            })
            .then(() => {
                setUser(prevState => ({...prevState, password: '', passwordConfirm: ''}));
                setAlertMessage('Atualizado com sucesso');
                setAlertColor('blue');
                setShowAlert(true)

            })
            .catch((err) => {
                setAlertColor('red');
                setShowAlert(true);
                if (err.response.status) {
                    const errors = err.response.data.errors;
                    if (err.response.status === 404) {

                        setAlertMessage('Registro não encontrado');
                        return
                    }
                    if (err.response.status === 422) {
                        setAlertMessage(errors[Object.keys(errors)[0]][0])
                        return;
                    }
                }
                setAlertMessage('Erro ao Atualizar. Por favor tente novamente mais tarde.');
                console.log(err);
            })
            .finally(() => setLoading(false));
    }

    const handleInputChange = event => {
        const {name, value} = event.target;

        setUser(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const hadleSave = () => {
        if (user.document && !cpf.isValid(user.document)) {
            if (!cnpj.isValid(user.document)) {
                setAlertColor('red');
                setAlertMessage('Documento invalido');
                setShowAlert(true);
                return;
            }
        }

        if (user.erpCode && user.erpCode.length !== 6) {
            setAlertColor('red');
            setAlertMessage('O codigo precisa ter 6 digitos');
            setShowAlert(true);
            return;
        }
        if (user.password) {
            if (user.password.length < 6) {
                setAlertColor('red');
                setAlertMessage('A senha precisa ter no minimo 6 digitos');
                setShowAlert(true);
                return;
            }
            if (user.password !== user.passwordConfirm) {
                setAlertColor('red');
                setAlertMessage('As senhas não são iguais');
                setShowAlert(true);
                return;
            }
        }
        setShowAlert(false);
        setLoading(true);
        if (isEdit) {
            handleEdit();
            return

        }
        handleNew();
    }

    return (
        <>
            <div className="py-10 justify-between flex px-10">
                <div className="flex text-blue-500">
                    <button onClick={() => {
                        navigate(-1);
                    }}>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24"
                             stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round"
                                  d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"/>
                        </svg>
                    </button>
                    <h2 className="text-3xl font-semibold mr-10">Usuário</h2>
                </div>
                <Spinner loading={loading}/>
                <div/>
            </div>
            <div className="mt-10 sm:mt-0 max-w-screen-lg flex flex-col">
                <div className="md:grid md:grid-cols-3 md:gap-6">
                    <div className="sm:pl-10 pl-0 mt-5 md:mt-0 md:col-span-2">
                        <form method="POST" onSubmit={(e) => {
                            e.preventDefault();
                            hadleSave();
                        }}>
                            <div className="shadow overflow-hidden shadow-xl border-gray-200 border-2 rounded-md">
                                <div className="px-4 py-5 sm:p-6">
                                    <div className="grid grid-cols-6 gap-6">
                                        {inputs.map((input) => (
                                            <div key={input.name} className="col-span-6 sm:col-span-3">
                                                <Input
                                                    label={input.label}
                                                    required={input.required}
                                                    value={user[input.name] ?? ''}
                                                    type={input.type}
                                                    name={input.name}
                                                    disabled={isView}
                                                    handleChange={handleInputChange}
                                                    autoComplete={`user.${input.name}`}
                                                />
                                            </div>
                                        ))}
                                        <div className="col-span-6 sm:col-span-3">
                                            <Select
                                                value={user.type ?? ''}
                                                label="Tipo*"
                                                name="type"
                                                onChange={handleInputChange}
                                                disabled={isView}>
                                                <option value="">Escolha uma opção</option>
                                                <option value="1">Admin</option>
                                                <option value="2">Cliente</option>
                                            </Select>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-4 py-3 text-right sm:px-6">
                                    <button disabled={isView} type="submit"
                                            className="inline-flex justify-center py-2 px-4 disabled:cursor-not-allowed disabled:opacity-50
                                        border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600
                                         hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                        Salvar
                                    </button>
                                </div>
                            </div>
                            <div className="text-center m-auto mt-5 w-3/4 max-w-xs ">
                                <Alert
                                    show={showAlert}
                                    alertOpen={setShowAlert}
                                    color={alertColor}
                                    message={alertMessage}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}